export default `body {
    padding: 10px 0;
    font-family: "Arial", sans-serif;
    line-height: normal;
}
.a4__size {
    max-width:  595px;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
}


.check__wrapper {
    overflow: hidden
}

.check__wrapper-left {
    width: calc(70% - 24px);
    float: left;
}

.check__wrapper-right {
    width: 30%;
    float: right;
}

.bordered {
    width: 100%;
    border: 1px solid #000000;
    padding: 5px 8px;
}

.table__main {

}

.table__main table {
    width: 100%;
    padding: 0;
    border-spacing: 0;
    margin: 0;
    /* border: 1px solid #000000; */
    text-align: center
}

.table__main table td {
    border: 1px solid #000000;
    border-bottom: none;
    border-right: none;
    height: 22px;
    font-size: 12px;
    padding: 2px 3px;
}

.table__main table th {
    border: 1px solid #000000;
    border-bottom: none;
    border-right: none;
    height: 22px;
    font-size: 12px;
    padding: 2px 3px;
}

.table__main table th:last-child {
    border-right: 1px solid #000000;
}

.table__main table td:last-child {
    border-right: 1px solid #000000;
}

.table__main table tr {
}

.table__main table tr:last-child td {
    border-bottom: 1px solid #000;
}

.table__main table tr td:last-child.border__none {
    border-right: none;
}

.table__main .border__none {
    border-left: none;
    border-right: none;
    height: 10px;
}

.table__main .border__top-none {
    border-top: none;
}

.border__left-none {
    border-left: none!important;
}

.border-bottom {
    border-bottom: 1px solid #000!important;
}

.cutting__line {
    position: relative
}

.cutting__line::before {
    content: '';
    position: absolute;
    height: 50px;
    width: 1px;
    left: -12px;
    bottom: 10px;
    background: #000000;
}

/* Agreement page starts here */

.agreement__block {
    overflow: hidden;
    text-align: center;
}

.block__title {
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    margin-top: 25px;
}

.block__subtitle {
    font-size: 10px;
    font-weight: bold;
    margin-top: 5px;
}

.block__date {
    margin-left: auto;
    font-size: 10px;
    font-weight: bold;
    text-align: right;
    margin-top: 10px;
}

.block__text {
    font-size: 10px;
    text-align: center;
    margin-bottom: 10px;
    font-weight: normal;
}

.agreement__table {
    margin-top: 20px;
}

.total__price {
    text-align: right;
    margin-top: 5px;
}

.total__price b {
    font-size: 10px;
    font-weight: bold;
    margin-right: 5px;
}

.total__price span {
    font-size: 10px;
}

.tdu {
    text-decoration: underline;
}

.block__ul {
    text-align: left;
    padding-left: 0;
    margin-top: 8px;
}

.obligations__name {
    text-align: left;
    margin-bottom: 0!important;
    margin-top: 15px;
}

.block__ul li {
    list-style-type: none;
    text-align: left;
    font-size: 10px;
    line-height: 1.2;
    margin-top: 5px;
    margin-bottom: 5px;
}

.agreement__mt {
    margin-top: 30px;
}

.address__main {
display: flex
}

.address__column {
    margin-top: 10px;
}

.address__column table {
    min-height: 212px;
}

.address__left {
    float: left;
    width: 50%;
}

.address__right {
    float: right;
    width: calc(50% - 10px);
}

.address__name {
    font-size: 10px;
    font-weight: bold;
    margin-bottom: 10px;
}

.address__column .table__main td {
    font-size: 10px !important;
}

.address__text {
    margin-top: 20px;
    font-size: 10px;
    text-align: left;
}

.address__text b {
    font-weight: bold;
    margin-right: 5px;
}

.address__text span {

}


/* Agreement page ends here*/

/* Graphic page starts here */

.a4__landscape {
    width:  1123px;
    margin-left: auto;
    margin-right: auto;
}

.block__column {
    width: calc(50% - 10px);
}

.bold__text {
    font-weight: bold;
}

.block__huge-text {
    font-size: 14px;
    font-weight: bold;
    text-align: center;
}

.border__bottom {
    border-bottom: 1px solid #000!important;
}
.border-top__none {
    border-top: none!important;
}

.border-bottom__none {
    border-bottom: none!important;
}

.border-right__none {
    border-right: none!important;
}

.border-left__none {
    border-left: none!important;
}

.border__right-none {
    border-right: none!important;
}

.block__wrapper {
    overflow: hidden
}

.block__left {
    float: left;
}

.block__right {
    float: right;
}

/* Graphic page starts here */

/* Invoice page starts here */

.invoice__table {
    margin-top: 40px;
}

.invoice__table td {
    max-width: 150px;
}

.border__right {
    border-right: 1px solid #000;
}

.table__lil-colspan {
    padding: 2px 3px;
}

.invoice__bottom-text {
    overflow: hidden
}

.invoice__bottom-left {
    float: left;
}

.invoice__bottom-right {
    float: right;
}`